import { useState, useEffect } from 'react';
import {
  IEmailLogContentDTO,
  IEmailInboxRecordsDTO,
  IAutomatedEmailCampaignListPayload,
  getAutomatedEmailCampaignList,
  IPaginationAPIResponse,
  ILocation,
} from 'wisestep-api';

export interface InboxEmailLogsType {
  lastIndexRead: number;
  totalCount: number;
  records: IEmailInboxRecordsDTO[];
}
export interface SentEmailLogsType {
  list: IEmailLogContentDTO[];
  totalCount: number;
  failed: number;
  sent: number;
}

export interface IEmailCampaignLog {
  jobId: string;
  jobTitle: string;
  jobCode: string;
  locations: ILocation[];
  companyName: string;
  campaignCode: string;
  status: string;
  count: number;
  responseCount: number;
  createdOn: Date;
}

const useGetEmailCampaignLogs = (search: IAutomatedEmailCampaignListPayload) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [emailCampaignList, setEmailCampaignList] = useState<
    IPaginationAPIResponse<IEmailCampaignLog>
  >({} as IPaginationAPIResponse<IEmailCampaignLog>);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await getAutomatedEmailCampaignList(search);
        if (data) {
          setEmailCampaignList(data);
        }
      } catch {
        console.error('Error while getting the setting campaign list');
      } finally {
        setLoading(false);
      }
    })();
  }, [search]);

  return { emailCampaignList, loading };
};
export default useGetEmailCampaignLogs;
